import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  SimpleChanges,
} from '@angular/core';
import { BriefOverviewDto, BriefResponseDto } from '@/app/common/general-types/briefs.dto';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { BriefService } from '@/app/services/brief/brief.service';
import {
  distinctUntilChanged,
  Subscription,
  debounceTime,
  firstValueFrom,
} from 'rxjs';
import { Router, RouterLink } from '@angular/router';

type LoadingState = 'idle' | 'loading' | 'loaded' | 'error';

@Component({
  selector: 'dbv2-latest-briefs',
  imports: [RouterLink],
  templateUrl: './latest-briefs.html',
  styleUrl: './latest-briefs.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LatestBriefs implements OnInit, OnDestroy {
  latestBriefs = signal<BriefOverviewDto[]>([]);
  loadingState = signal<LoadingState>('loading');

  private readonly overviewFromDate = new Date(0);
  private readonly subscriptionList = new Subscription();

  private readonly briefService = inject(BriefService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly router = inject(Router);
  /** Placeholder rows rendered while channels load. */
  protected readonly skeletonRows = [0, 1, 2, 3, 4];

  constructor() {
    this.currentUserService.focussedBrandSubject.pipe(
      debounceTime(350),
      distinctUntilChanged()
    ).subscribe((brand: any) => {
      console.log('🎃🎃🎃🎃 DE - Bounce - brand: ', brand);
      if (brand) {
        this.getLatestBriefs(brand.id);
      }
    });
  }

  ngOnInit(): void {

  }

  getLatestBriefs(brandId: string) {
    this.briefService.getLatestBriefsForBusiness(this.overviewFromDate, brandId).subscribe(async (briefs: BriefResponseDto[]) => {
      console.log('🎃🎃🎃🎃 briefs: ', briefs);
      const sortedBriefs = await this.organiseOverviewList(briefs);
        this.latestBriefs.set(sortedBriefs);
        this.loadingState.set('loaded');
    });
  }

  async organiseOverviewList(overViewRes: BriefResponseDto[]): Promise<BriefOverviewDto[]> {
    // ✅ Reset the list first
    let sortedBriefs = [];

    const user = await firstValueFrom(this.currentUserService.getShoutUser());
    const latest_user_visit = user?.latest_user_visit;

    console.log('🎃🎃🎃🎃 latestUserVisit: ', latest_user_visit);

    if (overViewRes && overViewRes.length > 0) {
      for (let brief of overViewRes) {
        let display: BriefOverviewDto = {
          id: brief.id,
          title: brief.title,
          campaign: brief.campaign ? brief.campaign.campaignName : 'Maybe',
          invited: this.countStatus(brief.briefApplication, 1),
          invitedNew: this.countSince(brief.briefApplication, 1, latest_user_visit),
          applied: this.countStatus(brief.briefApplication, 2),
          appliedNew: this.countSince(brief.briefApplication, 2, latest_user_visit),
          hired: this.countStatus(brief.briefApplication, 3),
          hiredNew: this.countSince(brief.briefApplication, 3, latest_user_visit),
          started: this.countStatus(brief.briefApplication, 8),
          startedNew: this.countSince(brief.briefApplication, 8, latest_user_visit),
          complete: this.countStatus(brief.briefApplication, 7),
          completeNew: this.countSince(brief.briefApplication, 7, latest_user_visit),
        };

        sortedBriefs.push(display);
      }
    }

    return sortedBriefs;
  }

  countStatus(applications: any[], status: number) {
    let count = 0;
    for (let app of applications) {
      if (app.applicationStatus == status) {
        count++;
      }
    }
    return count;
  }

  countSince(applications: any[], status: number, fromDate: Date) {
    return 0;
  }

  navigateToBrief(briefId: string) {
    this.router.navigate(['/manage-brief', briefId]);
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }
}
